// SPDX-License-Identifier: AGPL-3.0-or-later
// Copyright (C) 2026 Ben Richardson <hi@ben.gy>
// Additional permissions under AGPL-3.0 section 7 apply — see ADDITIONAL-TERMS.md.

/** Serialise captured measurements to CSV — pure, unit-tested. */

import type { Measurement } from './types';

/** Escape a field for CSV (quote if it contains a comma, quote or newline). */
export function csvField(value: string): string {
  if (/[",\n\r]/.test(value)) {
    return `"${value.replace(/"/g, '""')}"`;
  }
  return value;
}

function round(n: number, dp = 2): string {
  if (!Number.isFinite(n)) return '';
  const f = Math.pow(10, dp);
  return String(Math.round(n * f) / f);
}

/** A measurements table as CSV, newest rows in the order given. */
export function toCsv(measurements: Measurement[]): string {
  const header = ['label', 'mode', 'angle_deg', 'tilt_x_deg', 'tilt_y_deg', 'grade_pct', 'roof_pitch', 'ratio', 'iso_time'];
  const lines = [header.join(',')];
  for (const m of measurements) {
    const iso = new Date(m.at).toISOString();
    const row = [
      csvField(m.label || ''),
      m.mode,
      round(m.angle),
      m.tiltX === undefined ? '' : round(m.tiltX),
      m.tiltY === undefined ? '' : round(m.tiltY),
      round(m.grade, 1),
      csvField(m.roofPitch),
      csvField(m.ratio),
      iso,
    ];
    lines.push(row.join(','));
  }
  return lines.join('\n') + '\n';
}
